(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      if(!window.sessionStorage.getItem('collectPresell') || window.sessionStorage.getItem('collectPresell')!= this.dataset.collectPresell){
        window.sessionStorage.setItem('collectPresell',this.dataset.collectPresell);
      }
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }
    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  console.log(document.querySelector('.cart__ctas button'))
  let button = document.querySelector('.cart__ctas button');
  function stopEvent(){
   (function () {
     if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) { 
        let xmlhttp;
        if (window.XMLHttpRequest) {
            xmlhttp = new XMLHttpRequest();
        }else {
            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
        }
        xmlhttp.abort();
        if (!!(window.attachEvent && !window.opera))
        {
            document.execCommand("stop");
        }else{
            window.stop();
        }
      }else { 
        setTimeout(()=>{
          const xhr = new XMLHttpRequest();
          xhr.abort();
        },200)
      }
    })();
  }
  button.addEventListener('click', function(event) {
    stopEvent();
    button.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  class CollectionDescription extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if(this.querySelector('.pro-card') && this.querySelector('.pro-card .pro-text .p-three') && this.querySelector('.pro-card .pro-text .p-three .collect-presell') && window.sessionStorage.getItem('collectPresell') ){
        this.querySelector('.pro-card .pro-text .p-three .collect-presell').innerText = window.sessionStorage.getItem('collectPresell')
      }
    }
  }
  customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-exceed-attribute"]) return;
  try {
    
  // class saleWords extends HTMLElement {
  //   constructor() {
  //     super();
  //   }
  //   connectedCallback() {
  //     if(window.sessionStorage.getItem('collectPresell')){
  //       this.querySelector('.product-presell').innerText = window.sessionStorage.getItem('collectPresell')
  //     }
  //     else{
  //       this.querySelector('.product-presell').style.display = 'none !important';
  //     }
  //   }
  // }
  // customElements.define('sale-words', saleWords);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-style"]) return;
  try {
    
  // class saleWords extends HTMLElement {
  //   constructor() {
  //     super();
  //   }
  //   connectedCallback() {
  //     if(window.sessionStorage.getItem('collectPresell')){
  //       this.querySelector('.product-presell').innerText = window.sessionStorage.getItem('collectPresell')
  //     }
  //     else{
  //       this.querySelector('.product-presell').style.display = 'none !important';
  //     }
  //   }
  // }
  // customElements.define('sale-words', saleWords);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-video-img"]) return;
  try {
    
  // class saleWords extends HTMLElement {
  //   constructor() {
  //     super();
  //   }
  //   connectedCallback() {
  //     if(window.sessionStorage.getItem('collectPresell')){
  //       this.querySelector('.product-presell').innerText = window.sessionStorage.getItem('collectPresell')
  //     }
  //     else{
  //       this.querySelector('.product-presell').style.display = 'none !important';
  //     }
  //   }
  // }
  // customElements.define('sale-words', saleWords);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // class saleWords extends HTMLElement {
  //   constructor() {
  //     super();
  //   }
  //   connectedCallback() {
  //     if(window.sessionStorage.getItem('collectPresell')){
  //       this.querySelector('.product-presell').innerText = window.sessionStorage.getItem('collectPresell')
  //     }
  //     else{
  //       this.querySelector('.product-presell').style.display = 'none !important';
  //     }
  //   }
  // }
  // customElements.define('sale-words', saleWords);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-grid-wrapper"] && !window.DesignMode) return;
  try {
    
  class swiperGridWrapper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let info = this.querySelector('#swiperGridWrapperInfo') && JSON.parse(this.querySelector('#swiperGridWrapperInfo').textContent);
      let autoplay = info.is_autoplay ? {
          delay: info.autoplay_speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
      } : false;
      let loop = info.is_loop;
      let id = this.dataset.sectionId;
      console.log(info)
      setTimeout(()=>{
        new Swiper(`.swiper${id}`,{
          loop,
          autoplay,
          pagination: {
            el: '.swiper-grid-wrapper-pagination',
          },
        })
      },1000);
    }
  }
  customElements.define('swiper-grid-wrapper', swiperGridWrapper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-img"] && !window.DesignMode) return;
  try {
    
    new Swiper('.swiper-img-text-box', {
      loop: true,
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      effect: 'fade',
      on:{
        slideChangeTransitionStart:function(e){
          let slide = this.slides && this.slides[this.realIndex];
          if(slide){
            let img = slide.querySelector('.blog-img-cover img');
            if(!img.src){
              img.src = img.getAttribute('data-url');
            }
          }
        }
      }
    });

  } catch(e) { console.error(e); }
})();
})();
